module.exports = __webpack_public_path__ + "static/media/bio_chem_1.1b822892.JPG";